<template>
  <vs-row
    vs-justify="center"
    vs-align="center"
    :class="'full-height ' + authClass"
  >
    <vs-col vs-lg="8" vs-sm="6" vs-xs="0"></vs-col>
    <vs-col
      type="flex"
      vs-justify="center"
      vs-align="center"
      class="p-0 full-height"
      vs-sm="6"
      vs-lg="4"
      vs-xs="12"
    >
      <vs-card class="mb-0 full-height login-box" id="login-box" fixedHeight>
        <div slot="header">
          <h3 class="mb-1">
            {{ $t("Auth.Login") }}
            <div v-if="enableCountry=='true'" class="float-right">
              <CountrySelector :selectable="true"></CountrySelector>
            </div>
            <div class="float-right">
              <LanguageSelector></LanguageSelector>
            </div>
          </h3>
        </div>
        <div class="p-4">
          <div class="text-center m-2 mb-5">
            <img :src="require('@/assets/logo-horizontal.png')" width="155" />
          </div>
          <vs-alert
            v-if="errors.length"
            class="mb-3 mt-2"
            color="danger"
          >
            <b>{{ $t("Auth.ErrorTitle") }}:</b>
            <ul class="common-list">
              <li v-for="error in errors" :key="error">{{ error }}</li>
            </ul>
          </vs-alert>
          <vs-alert v-if="alertVerifyByAdmin" class="mb-3 mt-2" color="success">
            <b>{{ $t("Auth.RegisterSuccess")[0] }}:</b>
            <ul class="common-list">
              <li>{{ $t("Auth.RegisterSuccess")[1] }}</li>
            </ul>
          </vs-alert>
          <form @submit="checkForm" @keyup.enter="checkForm" novalidate="true">
            <vs-input
              icon-after="true"
              size="large"
              class="w-100 mb-4 mt-2 vs-input-large"
              icon="email"
              :placeholder="$t('Auth.Email')"
              v-model="email"
              type="email"
            />
            <vs-input
              icon-after="true"
              size="large"
              class="w-100 vs-input-large"
              type="password"
              icon="lock"
              :placeholder="$t('Auth.Password')"
              v-model="password"
            />

            <div class="d-flex pt-3 pb-3">
              <vs-checkbox v-model="rememberme">{{
                $t("Auth.Remember")
              }}</vs-checkbox>
              <router-link to="/password/forgot" class="ml-auto"
                >{{ $t("Auth.ForgotPassword") }}
              </router-link>
            </div>
            <Captcha @captchaAcquired="setCaptchaKey" :regenerate="regenerateCaptcha" @captchaValue="setCaptchaValue"></Captcha>
            <vs-button
              class="btn-block btn btn-primary submit-button"
              type="submit"
              @click.stop.prevent="checkForm"
            >
              {{ $t("Auth.LoginButton") }}
            </vs-button>
          </form>

          <div v-if="enableRegister=='true'" class="d-flex justify-content-center mt-3">
            {{ $t("Auth.DontHaveAnAccount") }} &nbsp;
            <router-link to="/register">
              {{ $t("Auth.CreateAnAccount") }}</router-link
            >
          </div>
          <div v-if="enableActiveDir=='true'" class="d-flex justify-content-center mt-3">
            <vs-button
              class="btn-block btn border-primary submit-button"
              style="color: #008fc9"
              type="submit"
              @click.stop.prevent="checkFormAD"
            >
              {{ $t('Auth.LoginMS') }}
            </vs-button>
          </div>
        </div>
        <div slot="footer" class="text-center w-100">
          <AuthCopyright></AuthCopyright>
        </div>
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
import { mapState, mapActions } from "vuex";
import LanguageSelector from "../../components/language/LanguageSelector";
import CountrySelector from "../../components/country/CountrySelector";
import AuthCopyright from "../../components/copyright/AuthCopyright";
import { authBranding } from "../../_helpers/auth-branding";
import VueRecaptcha from 'vue-recaptcha';
import Captcha from "@/components/captcha/Captcha.vue";
export default {
  name: "Login",
  data: () => ({
    regenerateCaptcha:false,
    alertVerifyByAdmin: false,
    msg: "Login",
    rememberme: false,
    email: "",
    password: "",
    requestFailed: false,
    errors: [],
    recaptchaToken: null,
    captchaValue: null,
    captchaKey: null,
    enableRegister: false,
    enableCountry: false,
    enableActiveDir: false,
  }),
  methods: {
    setCaptchaKey(key) {
      this.captchaKey = key;
    },
    setCaptchaValue(value) {
      this.captchaValue = value;
    },
    checkForm: function(e) {
      this.captchaError = null;
      this.errors = [];
      if(this.captchaValue == null || this.captchaValue.length === 0) {
        this.errors.push(
            this.$t("Errors.Required", { field: this.$t("Auth.Captcha") })
        );
      } else {
      if (!this.email) {
        this.errors.push(
          this.$t("Errors.Required", { field: this.$t("Auth.Email") })
        );
      } else if (!this.validEmail(this.email)) {
        this.errors.push(
          this.$t("Errors.Invalid", { field: this.$t("Auth.Email") })
        );
      } else {
        this.submit();
        //this.$router.push('/dashboards/classic-dashboard');
      }
      if (!this.password)
        this.errors.push(
          this.$t("Errors.Required", { field: this.$t("Auth.Password") })
        );
      }
      if (!this.errors.length) return true;
      e.preventDefault();
    },
    checkFormAD: function(e) {
      this.captchaError = null;
      this.errors = [];
      if(this.captchaValue == null || this.captchaValue.length === 0) {
        this.errors.push(
            this.$t("Errors.Required", { field: this.$t("Auth.Captcha") })
        );
      } else {
      if (!this.email) {
        this.errors.push(
          this.$t("Errors.Required", { field: this.$t("Auth.Email") })
        );
      } else if (!this.validEmail(this.email)) {
        this.errors.push(
          this.$t("Errors.Invalid", { field: this.$t("Auth.Email") })
        );
      } else {
        this.submit(true);
        //this.$router.push('/dashboards/classic-dashboard');
      }
      if (!this.password)
        this.errors.push(
          this.$t("Errors.Required", { field: this.$t("Auth.Password") })
        );
      }
      if (!this.errors.length) return true;
      e.preventDefault();
    },
    /* eslint-disable */
    validEmail: function(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
      return re.test(email);
    },
    /* eslint-disable */
    submit(activeDirectory = false) {
      if (this.validEmail(this.email)) {
          this.handleSubmit(activeDirectory);
      } else {
        this.errors.push(
          this.$t("Errors.Invalid", { field: this.$t("Auth.Email") })
        );
      }
    },
    ...mapActions("account", ["login", "logout"]),
    handleSubmit(activeDirectory) {
      this.requestFailed = false;
      this.submitted = true;
      const { email, password } = this;
      if (email && password) {
        this.$vs.loading({
          container: "#login-box",
          scale: 0.6,
        });
          this.login({ email, password, key: this.captchaKey, captcha: this.captchaValue, ad: activeDirectory ? true : false})
              .catch(
                  function(data) {
                    this.errors.push(this.$t("Errors.LoginFail"));
                    this.requestFailed = true;
                    this.recaptchaToken = null;
                    this.regenerateCaptcha = !this.regenerateCaptcha;
                  }.bind(this)
              )
              .finally(
                  function() {
                    this.$vs.loading.close("#login-box > .con-vs-loading");
                    localStorage.setItem("env", "staging");
                  }.bind(this)
              );
      }
    },
    onCaptchaVerified: function (recaptchaToken) {
      this.recaptchaToken = recaptchaToken;
    },
    onCaptchaExpired: function () {
      this.$refs.recaptcha.reset();
      this.recaptchaToken = null;
    }
  },
  mounted() {
    if (localStorage.getItem("host") != null) {
      if (
        confirm(
          "You changed the original host. If you want to return to the default one click Ok."
        )
      ) {
        localStorage.removeItem("host");
        localStorage.removeItem("ws");
      }
    }
    if (this.$route.query.fromRegister) {
      this.alertVerifyByAdmin = true;
    } else this.alertVerifyByAdmin = false;
  },
  computed: {
    ...mapState("account", ["status"]),
    inputValid() {
      if (this.validEmail(this.email) && this.password && !this.requestFailed && (this.captchaValue == null || this.captchaValue.length === 0)) {
        return false;
      } else {
        return true;
      }
    },
    authClass() {
      return authBranding();
    },
  },
  created() {
    if(this.$enable_register) {
      this.enableRegister = this.$enable_register;
    }
    if(this.$enable_server_change) {
      this.enableCountry = this.$enable_server_change;
    }
    if(this.$enable_active_dir) {
      this.enableActiveDir = this.$enable_active_dir;
    }
    // reset login status
    //this.logout();
  },
  components: {
    Captcha,
    LanguageSelector,
    AuthCopyright,
    CountrySelector,
    VueRecaptcha
  },
};
</script>
